import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Listbox, Transition } from "@headlessui/react";
import { Toaster, ToastIcon, toast, resolveValue } from "react-hot-toast";
// import { createService } from '../api/customerRequest';
import { useDropdown } from "../store/dropdown-context";

import {
  fetchCity,
  fetchSuburb,
  fetchTechnical,
  fetchDeviceType,
  fetchAccountType,
  fetchComplaintValidity,
} from "../api/dropdown";
import { updateTicketById } from "../api/zoho";

const schema = yup.object().shape({
  status: yup.string(),
  cf_nw_alshkwy: yup.string(),
  requestType: yup.string(),
  accountCode: yup.string().notRequired(),
  accountType: yup.string(),
  clientName: yup.string().required(),
  phone: yup.string().required(),
  city: yup.string(),
  suburb: yup.string(),
  notes: yup.string().nullable(),
  notes2: yup.string().nullable(),
  notes3: yup.string().nullable(),
  technical: yup
    .object()
    .shape({
      name: yup.string(),
      phone1: yup.string().notRequired().nullable(),
      phone2: yup.string().notRequired().nullable(),
    })
    .nullable()
    .notRequired(),
  followedProcedure: yup.string().nullable().notRequired(),
  followedProcedureSuper: yup.string().nullable().notRequired(),
  complaintValidity: yup.string().nullable().notRequired(),
  responsibleEmployee: yup.string().nullable().notRequired(),
  salesCenter: yup.string().nullable().notRequired(),
  maintenanceCenter: yup.string().nullable().notRequired(),
  maintenanceTechnician: yup.string().nullable().notRequired(),
  cf_nw_aljhaz: yup.string().nullable().notRequired(),
  cf_nw_rmzAljhaz: yup
    .object()
    .shape({
      deviceType: yup.string(),
      deviceDescription: yup.string(),
      deviceCode: yup.string(),
    })
    .nullable()
    .notRequired(),
  updatedBy: yup.string().nullable().notRequired(),
});

const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className="transform p-4 flex bg-white rounded shadow-lg"
          enter="transition-all duration-150"
          enterFrom="opacity-0 scale-50"
          enterTo="opacity-100 scale-100"
          leave="transition-all duration-150"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-75"
        >
          <ToastIcon toast={t} />
          <p className="px-2">{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
// const people = ['تحت العمل', 'منتهي', 'منشأ'];
const people = [
  { id: 3, name: "منشأ" },
  { id: 1, name: "تحت العمل" },
  { id: 2, name: "منتهي" },
  { id: 3, name: "ملغي" },
];
// const complaintValidities = ['صحيحة', 'غير صحيحة ', 'تحت العمل'];
let complaintValidities = [
  { id: 1, name: "صحيحة" },
  { id: 2, name: "غير صحيحة" },
  { id: 3, name: "تحت العمل" },
];

let citys = [
  { id: 2, name: "مصراتة" },
  { id: 3, name: "بنغازي" },
];
let suburbs = [
  { id: 1, name: "11يونيو" },
  { id: 2, name: "الحي الاسلامي" },
  { id: 3, name: "السبعة" },
];
const complaintTypes = [
  { id: 1, name: "شكاوي التركيب" },
  { id: 2, name: "شكاوي الصيانة" },
  { id: 3, name: "شكاوي الاجهزة" },
  { id: 4, name: "شكاوي المبيعات" },
];
let accountTypes = [{ id: 1, name: "SRV" }];
// let technicals = [{ name: 'وليد العريبي', phone1: '0915109263', phone2: null }];
let technicals = [{ name: "لا يوجد", phone1: null, phone2: null }];
// let deviceTypes = ['مكيف', 'ثلاجة', 'خلاط', 'مروحة'];
let deviceCodesx = [
  {
    deviceId: 1,
    description: "مكيف هومر 9",
    deviceCode: "001.009.001.004",
  },
  {
    deviceId: 2,
    description: "مكيف هومر فيري -HS-12F/CH-12",
    name: "001.012.001.006",
  },
];
let deviceTypes = [{ name: "أخرى", id: 39, deviceCodes: [] }];

const UpdateComplaintFormScreen = () => {
  const {
    citysContext,
    accountTypeContext,
    technicalContext,
    deviceTypeContext,
    complaintValidityContext,
    agentNameContext,
  } = useDropdown();
  let { phoneNumber, id } = useParams();
  let navigate = useNavigate();
  const location = useLocation();
  const [selectedPerson, setSelectedPerson] = useState(people[0].name);
  const [xx, setxx] = useState("");
  const [selectedCity, setSelectedCity] = useState(citys[0]?.name);
  const [selectedSuburb, setSelectedSuburb] = useState();
  const [tktSource, setTktSource] = useState("");

  const [selectedComplaintType, setSelectedComplaintType] = useState(
    complaintTypes[0].name
  );
  const [selectedAccountType, setSelectedAccountType] = useState(
    accountTypes[0].name
  );
  const [selectedTechnical, setSelectedTechnical] = useState(technicals[0]);
  const [selectedComplaintValidity, setSelectedComplaintValidity] = useState(
    complaintValidities[0].name
  );
  const [selectedDeviceType, setSelectedDeviceType] = useState(deviceTypes[0]);
  const [selectedDeviceCode, setSelectedDeviceCode] = useState(deviceCodesx[0]);

  const onSubmit = (data, e) => {
    e.preventDefault();
    console.log(data);
    if (
      agentNameContext.length > 0 &&
      agentNameContext != undefined &&
      agentNameContext != null &&
      agentNameContext != ""
    ) {
      setValue("updatedBy", agentNameContext, {
        shouldValidate: true,
      });
    } else {
      let agentName = localStorage.getItem("agentName");
      setValue("updatedBy", agentName, {
        shouldValidate: true,
      });
    }
    setValue("city", selectedCity?.name, {
      shouldValidate: true,
    });
    setValue("suburb", selectedSuburb?.name, {
      shouldValidate: true,
    });
    setValue("technical", selectedTechnical, {
      shouldValidate: true,
    });
    setValue("cf_nw_alshkwy", selectedComplaintType, {
      shouldValidate: true,
    });
    setValue("status", selectedPerson, {
      shouldValidate: true,
    });
    setValue("accountType", selectedAccountType, {
      shouldValidate: true,
    });
    setValue("cf_nw_aljhaz", selectedDeviceType.name, {
      shouldValidate: true,
    });
    setValue('cf_nw_rmzAljhaz', selectedDeviceCode, {
      shouldValidate: true,
    });
    setValue("notes", location?.state?.account?.cf?.cf_mlahzat_1, {
      shouldValidate: true,
    });
    setValue("notes2", location?.state?.account?.cf?.cf_mlahzat_2, {
      shouldValidate: true,
    });
    setValue("notes3", location?.state?.account?.cf?.cf_mlahzat_3, {
      shouldValidate: true,
    });
    setTktSource(location?.state?.account?.cf?.cf_msdr_altdhkrt);

    updateTicketById(data, id, "complaint")
      .then((res) => {
        toast.success("تم التعديل");
        setTimeout(() => {}, 2000);
        signupHandler();
      })
      .catch((err) => {
        toast.error("حدث خطا");
        setTimeout(() => {}, 2000);
      });
  };
  const onError = (errors, e) => console.log(errors, e);
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const signupHandler = async () => {
    navigate(`/CalLlogsScreen/${phoneNumber}`);
  };
  useEffect(() => {
    console.log(errors, "errors");
  }, [errors]);

  useEffect(() => {
    // setLoadding(true);
    // setError('');
    deviceTypes = deviceTypeContext;
    setSelectedDeviceType(deviceTypes[0]);
    deviceCodesx = deviceTypes[0].deviceCodes;
    if (deviceCodesx?.length > 0) {
      setSelectedDeviceCode(deviceCodesx[0]);
    }
    try {
      accountTypes = accountTypeContext;
      citys = citysContext;
      complaintValidities = complaintValidityContext;
      async function fetchData() {
        const technicalRes = await fetchTechnical();

        if (technicalRes.data.success) {
          technicals = technicalRes.data.data;
          technicals.sort(function (a, b) {
            return a.name.localeCompare(b.name, ["ar"]);
          });
          technicals.unshift({ name: "لا يوجد", phone1: null, phone2: null });
        }
      }
      fetchData().then((rex) => {
        if (location.state) {
          console.log(location?.state?.account);
          setSelectedPerson(location?.state?.account?.status);

          setValue("status", location?.state?.account?.status, {
            shouldValidate: true,
          });
          setSelectedComplaintType(location?.state?.account?.cf?.cf_nw_alshkwy);
          setValue(
            "cf_nw_alshkwy",
            location?.state?.account?.cf?.cf_nw_alshkwy,
            {
              shouldValidate: true,
            }
          );
          setValue("accountCode", location?.state?.account?.contact?.id, {
            shouldValidate: true,
          });
          setSelectedAccountType(location?.state?.account?.cf?.cf_nw_alhsab);
          setValue("accountType", location?.state?.account?.cf?.cf_nw_alhsab, {
            shouldValidate: true,
          });
          setValue(
            "clientName",
            location?.state?.account?.contact?.firstName +
              " " +
              location?.state?.account?.contact?.lastName,
            {
              shouldValidate: true,
            }
          );
          setValue("phone", location?.state?.account?.phone, {
            shouldValidate: true,
          });
          setTktSource(location?.state?.account?.cf?.cf_msdr_altdhkrt);

          setSelectedCity(
            citys.find(
              (element) =>
                element?.name === location?.state?.account?.cf?.cf_almdynt
            )
          );
          setxx(location?.state?.account?.cf?.cf_aldahyt);
          setValue("notes", location?.state?.account?.cf?.cf_mlahzat_1, {
            shouldValidate: true,
          });
          setValue("notes2", location?.state?.account?.cf?.cf_mlahzat_2, {
            shouldValidate: true,
          });
          setValue("notes3", location?.state?.account?.cf?.cf_mlahzat_3, {
            shouldValidate: true,
          });
          // setValue('technical', location?.state?.account?.cf?.cf_alfny_almfdl, {
          //   shouldValidate: true,
          // });
          let xy = technicals.find(
            (element) =>
              element.name === location?.state?.account?.cf?.cf_alfny_almfdl
          );
          setSelectedTechnical(xy ? xy : technicals[0]);
          console.log(location?.state?.account?.cf?.cf_alfny_almfdl);
          setValue(
            "followedProcedure",
            location?.state?.account?.cf?.cf_alajra_almtb,
            {
              shouldValidate: true,
            }
          );
          setValue(
            "followedProcedureSuper",
            location?.state?.account?.cf?.cf_alajra_almtb_mn_almswwl,
            {
              shouldValidate: true,
            }
          );
          setSelectedComplaintValidity(
            location?.state?.account?.cf?.cf_sht_alshkwy
          );
          setValue(
            "complaintValidity",
            location?.state?.account?.cf?.cf_sht_alshkwy,
            {
              shouldValidate: true,
            }
          );
          setValue(
            "responsibleEmployee",
            location?.state?.account?.cf?.cf_almwzf_almswwl,
            {
              shouldValidate: true,
            }
          );
          setValue(
            "salesCenter",
            location?.state?.account?.cf?.cf_asm_mrkz_almbyat,
            {
              shouldValidate: true,
            }
          );
          setValue(
            "maintenanceCenter",
            location?.state?.account?.cf?.cf_asm_mrkz_alsyant,
            {
              shouldValidate: true,
            }
          );
          setValue(
            "maintenanceTechnician",
            location?.state?.account?.cf?.cf_asm_fny_alsyant,
            {
              shouldValidate: true,
            }
          );

          setValue("cf_nw_aljhaz", location?.state?.account?.cf?.cf_nw_aljhaz, {
            shouldValidate: true,
          });
          if (
            location?.state?.account?.cf?.cf_rmz_aljhaz.includes("undefined")
          ) {
            setSelectedDeviceCode("لا يوجد/لايوجد");
          } else {
            setSelectedDeviceCode(location?.state?.account?.cf?.cf_rmz_aljhaz);
          }
          if (
            agentNameContext.length > 0 &&
            agentNameContext != undefined &&
            agentNameContext != null &&
            agentNameContext != ""
          ) {
            setValue("updatedBy", agentNameContext, {
              shouldValidate: true,
            });
          } else {
            let agentName = localStorage.getItem("agentName");
            setValue("updatedBy", agentName, {
              shouldValidate: true,
            });
          }
        }
      });

      // setLoadding(false);
    } catch (error) {
      // setError(error.message);
    }
  }, []);

  useEffect(() => {
    setValue("city", selectedCity?.name, {
      shouldValidate: true,
    });
    setValue("suburb", selectedSuburb?.name, {
      shouldValidate: true,
    });
    setValue("status", selectedPerson, {
      shouldValidate: true,
    });
    setValue("cf_nw_alshkwy", selectedComplaintType, {
      shouldValidate: true,
    });
    setValue("accountType", selectedAccountType, {
      shouldValidate: true,
    });
    setValue("technical", selectedTechnical, {
      shouldValidate: true,
    });
    setValue("cf_nw_aljhaz", selectedDeviceType.name, {
      shouldValidate: true,
    });
    setValue("cf_nw_aljhaz", selectedDeviceType?.name, {
      shouldValidate: true,
    });
    setValue("cf_nw_rmzAljhaz", selectedDeviceCode, {
      shouldValidate: true,
    });
    setValue("cf_nw_rmzAljhaz", selectedDeviceCode, {
      shouldValidate: true,
    });
    setValue("complaintValidity", selectedComplaintValidity, {
      shouldValidate: true,
    });
  }, [
    selectedCity,
    selectedSuburb,
    selectedComplaintType,
    selectedPerson,
    selectedAccountType,
    selectedTechnical,
    selectedDeviceType,
    selectedComplaintValidity,
    setValue,
    selectedDeviceCode,
  ]);
  useEffect(() => {
    deviceCodesx = selectedDeviceType?.deviceCodes;
    console.log(selectedDeviceType?.deviceCodes);
    setSelectedDeviceCode(deviceCodesx[0]);
  }, [selectedDeviceType]);
  // useEffect(() => {
  //   deviceCodesx = selectedDeviceType?.deviceCodes;
  //   console.log(selectedDeviceType?.deviceCodes);
  //   setSelectedDeviceCode(deviceCodesx[0]);
  // }, [selectedDeviceType]);

  useEffect(() => {
    if (xx?.length > 0 && selectedCity?.name !== xx) {
      setSelectedSuburb(
        selectedCity?.Suburbs.find((element) => element?.name === xx)
      );
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
      } else {
        suburbs = [selectedCity];
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        setSelectedSuburb(suburbs[0]);
      }
    } else {
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        setSelectedSuburb(suburbs[0]);
      } else {
        suburbs = [selectedCity];
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        setSelectedSuburb(suburbs[0]);
      }
    }
  }, [selectedCity]);

  return (
    <div
      className="bg-background-100 h-full min-h-screen w-full flex flex-col container px-36 py-20"
      dir="rtl"
    >
      <div className="mx-auto ">
        <p className="text-title-100 text-xl font-bold">
          رقم التذكرة: {location?.state?.account?.ticketNumber}
        </p>
      </div>
      <div className="pt-14 justify-between flex ">
        <p className="text-title-100 text-xl ">
          التاريخ: {location?.state?.account?.createdTime?.split("T")[0]}
        </p>
      </div>
      <div className="pt-4 justify-between flex ">
        <p className="text-title-100 text-xl ">أمر العمل: {id}</p>
      </div>
      <div className="grid grid-cols-3 gap-44">
        <div className="flex  pt-12">
          <div className="w-full  ">
            <Listbox
              as="div"
              className="space-y-1"
              value={selectedPerson}
              onChange={setSelectedPerson}
            >
              {({ open }) => (
                <>
                  <Listbox.Label className="block  leading-5 text-title-100 text-xl ">
                    حالة النموذج
                  </Listbox.Label>
                  <div className="relative">
                    <span className="inline-block w-full rounded-md shadow-sm">
                      <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <span className="block truncate">{selectedPerson}</span>
                        <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                          <svg
                            className="h-5 w-5 text-gray-400"
                            viewBox="0 0 20 20"
                            fill="none"
                            stroke="currentColor"
                          >
                            <path
                              d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </Listbox.Button>
                    </span>

                    <Transition
                      show={open}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                      className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                    >
                      <Listbox.Options
                        static
                        className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                      >
                        {people.map((person) => (
                          <Listbox.Option key={person.name} value={person.name}>
                            {({ selected, active }) => (
                              <div
                                className={`${
                                  active
                                    ? "text-white bg-blue-600"
                                    : "text-gray-900"
                                } cursor-default select-none relative py-2 pl-8 pr-4`}
                              >
                                <span
                                  className={`${
                                    selected ? "font-semibold" : "font-normal"
                                  } block truncate`}
                                >
                                  {person.name}
                                </span>
                                {selected && (
                                  <span
                                    className={`${
                                      active ? "text-white" : "text-blue-600"
                                    } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                  >
                                    <svg
                                      className="h-5 w-5"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </span>
                                )}
                              </div>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox>
          </div>
        </div>
        <div className="flex  pt-12">
          <div className="w-full  ">
            {/* <Listbox
              as='div'
              className='space-y-1'
              value={selectedComplaintType}
              onChange={setSelectedComplaintType}
            >
              {({ open }) => (
                <>
                  <Listbox.Label className='block  leading-5 text-title-100 text-xl '>
                    نوع الشكوى
                  </Listbox.Label>
                  <div className='relative'>
                    <span className='inline-block w-full rounded-md shadow-sm'>
                      <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                        <span className='block truncate'>
                          {selectedComplaintType}
                        </span>
                        <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                          <svg
                            className='h-5 w-5 text-gray-400'
                            viewBox='0 0 20 20'
                            fill='none'
                            stroke='currentColor'
                          >
                            <path
                              d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                              strokeWidth='1.5'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            />
                          </svg>
                        </span>
                      </Listbox.Button>
                    </span>

                    <Transition
                      show={open}
                      leave='transition ease-in duration-100'
                      leaveFrom='opacity-100'
                      leaveTo='opacity-0'
                      className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                    >
                      <Listbox.Options
                        static
                        className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5'
                      >
                        {complaintTypes.map((person) => (
                          <Listbox.Option key={person.name} value={person.name}>
                            {({ selected, active }) => (
                              <div
                                className={`${
                                  active
                                    ? 'text-white bg-blue-600'
                                    : 'text-gray-900'
                                } cursor-default select-none relative py-2 pl-8 pr-4`}
                              >
                                <span
                                  className={`${
                                    selected ? 'font-semibold' : 'font-normal'
                                  } block truncate`}
                                >
                                  {person.name}
                                </span>
                                {selected && (
                                  <span
                                    className={`${
                                      active ? 'text-white' : 'text-blue-600'
                                    } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                  >
                                    <svg
                                      className='h-5 w-5'
                                      xmlns='http://www.w3.org/2000/svg'
                                      viewBox='0 0 20 20'
                                      fill='currentColor'
                                    >
                                      <path
                                        fillRule='evenodd'
                                        d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                        clipRule='evenodd'
                                      />
                                    </svg>
                                  </span>
                                )}
                              </div>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox> */}
            <label htmlFor="" className=" text-title-100 text-md block">
              <span className="px-1">نوع الشكوى</span>
            </label>
            <input
              name="cf_nw_alshkwy"
              disabled
              {...register("cf_nw_alshkwy")}
              type="cf_nw_alshkwy"
              className="w-full p-2 border border-gray-300 rounded mt-1"
            />
            <p className=" opacity-50 text-s">
              {errors?.cf_nw_alshkwy?.message}
            </p>
          </div>
        </div>
        <div className="pt-12">

          <label htmlFor="" className=" text-title-100 text-md">
            <span className="px-1">مصدر التذكرة</span>
          </label>
          <input
            name="tktSource"
            disabled
            value={tktSource || "مكالمة هاتفية"}
            type="tktSource"
            className="w-full p-2 border border-gray-300 rounded mt-1"
          />
          <p className=" opacity-50 text-s">
            {errors?.serviceRequestType?.message}
          </p>
        </div>
      </div>

      <div className="py-12">
        <p className="text-title-100 text-xl">بيانات العميل</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className="flex flex-col space-y-6 ">
          <div className="grid grid-cols-2 gap-44">
            <div>
              <label htmlFor="" className=" text-title-100 text-md block">
                <span className="px-1">رقم العميل</span>
              </label>
              <input
                name="accountCode"
                disabled
                {...register("accountCode")}
                type="accountCode"
                className="w-full p-2 border border-gray-300 rounded mt-1"
              />
              <p className=" opacity-50 text-s">
                {errors?.accountCode?.message}
              </p>
            </div>
            <div className="flex ">
              <div className="w-full  ">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedAccountType}
                  onChange={setSelectedAccountType}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        نوع الحساب
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedAccountType}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                          >
                            {accountTypes.map((city) => (
                              <Listbox.Option
                                key={city?.name}
                                value={city?.name}
                              >
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {city?.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>{" "}
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div>
              <label htmlFor="" className=" text-title-100 text-md block">
                <span className="px-1">الاسم</span>
              </label>
              <input
                name="clientName"
                {...register("clientName")}
                type="clientName"
                disabled
                className="w-full p-2 border border-gray-300 rounded mt-1"
              />
              <p className=" opacity-50 text-s">
                {errors?.clientName?.message}
              </p>
            </div>
            <div>
              <label htmlFor="" className=" text-title-100 text-md block">
                <span className="px-1">رقم الهاتف</span>
              </label>
              <input
                name="phone"
                {...register("phone")}
                type="phone"
                className="w-full p-2 border border-gray-300 rounded mt-1"
              />
              <p className=" opacity-50 text-s">{errors?.phone?.message}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="flex ">
              <div className="w-full  z-30">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedCity}
                  onChange={setSelectedCity}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        المدينة
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedCity?.name}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                          >
                            {citys?.map((person) => (
                              <Listbox.Option key={person?.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person?.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>{" "}
            <div className="flex  ">
              <div className="w-full  z-30">
                <Listbox
                  as="div"
                  className="space-y-1"
                  value={selectedSuburb}
                  onChange={setSelectedSuburb}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                        الضاحية
                      </Listbox.Label>
                      <div className="relative">
                        <span className="inline-block w-full rounded-md shadow-sm">
                          <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                            <span className="block truncate">
                              {selectedSuburb?.name}
                            </span>
                            <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                              <svg
                                className="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor"
                              >
                                <path
                                  d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </Listbox.Button>
                        </span>

                        <Transition
                          show={open}
                          leave="transition ease-in duration-100"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                          className=" absolute mt-1 w-full rounded-md bg-white shadow-lg"
                        >
                          <Listbox.Options
                            static
                            className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                          >
                            {suburbs?.map((person) => (
                              <Listbox.Option key={person?.name} value={person}>
                                {({ selected, active }) => (
                                  <div
                                    className={`${
                                      active
                                        ? "text-white bg-blue-600"
                                        : "text-gray-900"
                                    } cursor-default select-none relative py-2 pl-8 pr-4`}
                                  >
                                    <span
                                      className={`${
                                        selected
                                          ? "font-semibold"
                                          : "font-normal"
                                      } block truncate`}
                                    >
                                      {person?.name}
                                    </span>
                                    {selected && (
                                      <span
                                        className={`${
                                          active
                                            ? "text-white"
                                            : "text-blue-600"
                                        } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                      >
                                        <svg
                                          className="h-5 w-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </Transition>
                      </div>
                    </>
                  )}
                </Listbox>
              </div>
            </div>
          </div>
          {selectedComplaintType == "شكاوي التركيب" && (
            <>
              <div className="grid grid-cols-2 gap-44">
                <div className="flex ">
                  <div className="w-full z-10 ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedTechnical}
                      onChange={setSelectedTechnical}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            الفني المفضل
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedTechnical.name}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {technicals.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {person.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{" "}
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع</span>
                  </label>
                  <input
                    name="followedProcedure"
                    {...register("followedProcedure")}
                    type="followedProcedure"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedure?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="flex ">
                  <div className="w-full  ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedComplaintValidity}
                      onChange={setSelectedComplaintValidity}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            صحة الشكوى
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedComplaintValidity}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className=" rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {complaintValidities.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person.name}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {person.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{" "}
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع من المسؤول</span>
                  </label>
                  <input
                    name="followedProcedureSuper"
                    {...register("followedProcedureSuper")}
                    type="followedProcedureSuper"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedureSuper?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الموظف المسؤول</span>
                  </label>
                  <input
                    name="responsibleEmployee"
                    {...register("responsibleEmployee")}
                    type="responsibleEmployee"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.responsibleEmployee?.message}
                  </p>
                </div>
              </div>
            </>
          )}
          {selectedComplaintType == "شكاوي المبيعات" && (
            <>
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">اسم مركز المبيعات</span>
                  </label>
                  <input
                    name="salesCenter"
                    {...register("salesCenter")}
                    type="salesCenter"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.salesCenter?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع</span>
                  </label>
                  <input
                    name="followedProcedure"
                    {...register("followedProcedure")}
                    type="followedProcedure"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedure?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="flex ">
                  <div className="w-full  ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedComplaintValidity}
                      onChange={setSelectedComplaintValidity}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            صحة الشكوى
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedComplaintValidity}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className=" rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {complaintValidities.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person.name}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {person.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{" "}
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع من المسؤول</span>
                  </label>
                  <input
                    name="followedProcedureSuper"
                    {...register("followedProcedureSuper")}
                    type="followedProcedureSuper"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedureSuper?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الموظف المسؤول</span>
                  </label>
                  <input
                    name="responsibleEmployee"
                    {...register("responsibleEmployee")}
                    type="responsibleEmployee"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.responsibleEmployee?.message}
                  </p>
                </div>
              </div>
            </>
          )}
          {selectedComplaintType == "شكاوي الصيانة" && (
            <>
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">اسم مركز الصيانة</span>
                  </label>
                  <input
                    name="maintenanceCenter"
                    {...register("maintenanceCenter")}
                    type="maintenanceCenter"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.maintenanceCenter?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">اسم فني الصيانة</span>
                  </label>
                  <input
                    name="maintenanceTechnician"
                    {...register("maintenanceTechnician")}
                    type="maintenanceTechnician"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.maintenanceTechnician?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="flex ">
                  <div className="w-full  ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedComplaintValidity}
                      onChange={setSelectedComplaintValidity}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            صحة الشكوى
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedComplaintValidity}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className=" rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {complaintValidities.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person.name}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {person.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{" "}
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع</span>
                  </label>
                  <input
                    name="followedProcedure"
                    {...register("followedProcedure")}
                    type="followedProcedure"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedure?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الموظف المسؤول</span>
                  </label>
                  <input
                    name="responsibleEmployee"
                    {...register("responsibleEmployee")}
                    type="responsibleEmployee"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.responsibleEmployee?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع من المسؤول</span>
                  </label>
                  <input
                    name="followedProcedureSuper"
                    {...register("followedProcedureSuper")}
                    type="followedProcedureSuper"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedureSuper?.message}
                  </p>
                </div>
              </div>
            </>
          )}
          {selectedComplaintType == "شكاوي الاجهزة" && (
            <>
              <div className="grid grid-cols-2 gap-8">
                {/* <div className='flex '>
                  <div className='w-full z-10 '>
                    <Listbox
                      as='div'
                      className='space-y-1'
                      value={selectedDeviceType}
                      onChange={setSelectedDeviceType}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                            نوع الجهاز
                          </Listbox.Label>
                          <div className='relative'>
                            <span className='inline-block w-full rounded-md shadow-sm'>
                              <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                                <span className='block truncate'>
                                  {selectedDeviceType.name}
                                </span>
                                <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                  <svg
                                    className='h-5 w-5 text-gray-400'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    stroke='currentColor'
                                  >
                                    <path
                                      d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                      strokeWidth='1.5'
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave='transition ease-in duration-100'
                              leaveFrom='opacity-100'
                              leaveTo='opacity-0'
                              className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                            >
                              <Listbox.Options
                                static
                                className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5 '
                              >
                                {deviceTypes.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? 'text-white bg-blue-600'
                                            : 'text-gray-900'
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? 'font-semibold'
                                              : 'font-normal'
                                          } block truncate`}
                                        >
                                          {person.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? 'text-white'
                                                : 'text-blue-600'
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className='h-5 w-5'
                                              xmlns='http://www.w3.org/2000/svg'
                                              viewBox='0 0 20 20'
                                              fill='currentColor'
                                            >
                                              <path
                                                fillRule='evenodd'
                                                d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                                clipRule='evenodd'
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{' '}
                <div className='flex '>
                  <div className='w-full z-20 '>
                    <Listbox
                      as='div'
                      className='space-y-1'
                      value={selectedDeviceCode}
                      onChange={setSelectedDeviceCode}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                            اسم الجهاز
                          </Listbox.Label>
                          <div className='relative'>
                            <span className='inline-block w-full rounded-md shadow-sm'>
                              <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                                <span className='block truncate'>
                                  {selectedDeviceCode.description}
                                </span>
                                <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                  <svg
                                    className='h-5 w-5 text-gray-400'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    stroke='currentColor'
                                  >
                                    <path
                                      d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                      strokeWidth='1.5'
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave='transition ease-in duration-100'
                              leaveFrom='opacity-100'
                              leaveTo='opacity-0'
                              className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                            >
                              <Listbox.Options
                                static
                                className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5 '
                              >
                                {deviceCodesx.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? 'text-white bg-blue-600'
                                            : 'text-gray-900'
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? 'font-semibold'
                                              : 'font-normal'
                                          } block truncate`}
                                        >
                                          {person.description}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? 'text-white'
                                                : 'text-blue-600'
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className='h-5 w-5'
                                              xmlns='http://www.w3.org/2000/svg'
                                              viewBox='0 0 20 20'
                                              fill='currentColor'
                                            >
                                              <path
                                                fillRule='evenodd'
                                                d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                                clipRule='evenodd'
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>
                <div className='flex '>
                  <div className='w-full z-10 '>
                    <Listbox
                      as='div'
                      className='space-y-1'
                      value={selectedDeviceCode}
                      onChange={setSelectedDeviceCode}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className='block  leading-5 text-title-100 text-md '>
                            رمز الجهاز
                          </Listbox.Label>
                          <div className='relative'>
                            <span className='inline-block w-full rounded-md shadow-sm'>
                              <Listbox.Button className='cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5'>
                                <span className='block truncate'>
                                  {selectedDeviceCode.name}
                                </span>
                                <span className='absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none'>
                                  <svg
                                    className='h-5 w-5 text-gray-400'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    stroke='currentColor'
                                  >
                                    <path
                                      d='M7 7l3-3 3 3m0 6l-3 3-3-3'
                                      strokeWidth='1.5'
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave='transition ease-in duration-100'
                              leaveFrom='opacity-100'
                              leaveTo='opacity-0'
                              className='absolute mt-1 w-full rounded-md bg-white shadow-lg'
                            >
                              <Listbox.Options
                                static
                                className='max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5 '
                              >
                                {deviceCodesx.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? 'text-white bg-blue-600'
                                            : 'text-gray-900'
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? 'font-semibold'
                                              : 'font-normal'
                                          } block truncate`}
                                        >
                                          {person.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? 'text-white'
                                                : 'text-blue-600'
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className='h-5 w-5'
                                              xmlns='http://www.w3.org/2000/svg'
                                              viewBox='0 0 20 20'
                                              fill='currentColor'
                                            >
                                              <path
                                                fillRule='evenodd'
                                                d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                                                clipRule='evenodd'
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div> */}
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">نوع الجهاز</span>
                  </label>
                  <input
                    name="cf_nw_aljhaz"
                    disabled
                    {...register("cf_nw_aljhaz")}
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.cf_nw_aljhaz?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">رمز الجهاز</span>
                  </label>
                  <input
                    name="cf_nw_rmzAljhaz"
                    disabled
                    // {...register('cf_nw_rmzAljhaz')}
                    value={selectedDeviceCode.split("/")[0] || " "}
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <input
                    name="cf_nw_rmzAljhaz_1"
                    disabled
                    value={selectedDeviceCode.split("/")[1] || " "}
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.cf_nw_rmzAljhaz?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="flex ">
                  <div className="w-full  ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedComplaintValidity}
                      onChange={setSelectedComplaintValidity}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            صحة الشكوى
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedComplaintValidity}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className=" rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {complaintValidities.map((person) => (
                                  <Listbox.Option
                                    key={person.name}
                                    value={person.name}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {person.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{" "}
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع</span>
                  </label>
                  <input
                    name="followedProcedure"
                    {...register("followedProcedure")}
                    type="followedProcedure"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedure?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الموظف المسؤول</span>
                  </label>
                  <input
                    name="responsibleEmployee"
                    {...register("responsibleEmployee")}
                    type="responsibleEmployee"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.responsibleEmployee?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاجراء المتبع من المسؤول</span>
                  </label>
                  <input
                    name="followedProcedureSuper"
                    {...register("followedProcedureSuper")}
                    type="followedProcedureSuper"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.followedProcedureSuper?.message}
                  </p>
                </div>
              </div>
            </>
          )}
          <div className="grid grid-cols-2 gap-44">
            <div className="col-span-2">
              <label htmlFor="" className=" text-title-100 text-md block ">
                <span className="px-1 ">نص الشكوى</span>
              </label>
              <textarea
                rows="6"
                className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder=""
                name="notes3"
                {...register("notes3")}
              ></textarea>
              <p className=" opacity-50 text-s">{errors?.notes3?.message}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="col-span-2">
              <label htmlFor="" className=" text-title-100 text-md block ">
                <span className="px-1 ">ملاحظات</span>
              </label>
              <textarea
                rows="6"
                className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder=""
                name="notes"
                {...register("notes")}
              ></textarea>
              <p className=" opacity-50 text-s">{errors?.notes?.message}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="col-span-2">
              <label htmlFor="" className=" text-title-100 text-md block ">
                <span className="px-1 ">ملاحظات 2</span>
              </label>
              <textarea
                rows="6"
                className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder=""
                name="notes2"
                {...register("notes2")}
              ></textarea>
              <p className=" opacity-50 text-s">{errors?.notes2?.message}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-44">
            <div className="col-span-2">
              <label htmlFor="" className=" text-title-100 text-md block ">
                <span className="px-1 ">ملاحظات 3</span>
              </label>
              <textarea
                rows="6"
                className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                placeholder=""
              ></textarea>
              {/* <p className=' opacity-50 text-s'>{errors?.notes3?.message}</p> */}
            </div>
          </div>
        </div>
        <div className="pt-12 justify-center flex">
          {
            <button
              type="submit"
              className="text-white bg-button-100    font-medium  text-sm px-10 py-2.5 mr-2 mb-2   rounded "
              // onClick={() => signupHandler(ticket)}
            >
              تعديل
            </button>
          }
          <button
            type="button"
            className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white  border border-blue-500 hover:border-transparent rounded text-sm px-6 py-2.5 mr-2 mb-2    "
            onClick={() => signupHandler()}
          >
            الإستمرار
          </button>
        </div>
      </form>
      <TailwindToaster />
    </div>
  );
};

export default UpdateComplaintFormScreen;
